import React from "react";

const ProcessSection = () => {
  return (
    <section className="section section-alt" id="process">
      <div className="container">
        <div className="section-layout">
          <div className="section-copy">
            <p className="tag">How it works</p>
            <h2 className="section-title">
              Fibre, water and chocolate working as one delicious system.
            </h2>
            <p className="section-subtitle">
              Calowry is not a flavor, coating or sweetener. It is a patented
              way of structuring chocolate, fibre and water so that you can
              remove a large proportion of calories and net carbs while keeping a
              true chocolate bite.
            </p>

            <ul className="process-list">
              <li>
                <span className="process-step">01</span>
                <div>
                  <h3>Build the Calowry base</h3>
                  <p>
                    Our process integrates water into a chocolate plus fibre
                    network to create a stable, low calorie base.
                  </p>
                </div>
              </li>
              <li>
                <span className="process-step">02</span>
                <div>
                  <h3>Formulate for your application</h3>
                  <p>
                    Calowry can be tuned for bars, inclusions, fillings, enrobed
                    pieces and more, in both milk and dark profiles.
                  </p>
                </div>
              </li>
              <li>
                <span className="process-step">03</span>
                <div>
                  <h3>Scale with your existing lines</h3>
                  <p>
                    The process is designed to drop into conventional chocolate
                    manufacturing with minimal changes to equipment.
                  </p>
                </div>
              </li>
            </ul>
          </div>

          <div className="section-visual">
            <div className="stacked-card">
              <p className="stacked-label">Why it matters</p>
              <p className="stacked-body">
                Nearly half of humanity is now overweight, obese and/or living with diabetes. Previous attempts at 10-15% reduction diet chocolate have been blighted by unpalatable taste and severe gastro-intestinal side effects. Calowry is the only product and process in the world that allows greater than half reductions while maintaining the luxurious chocolate mouthfeel and no GI upset!
              </p>

              <ul className="stacked-metrics">
                <li>
                  <span className="metric-label">No sugar alcohols</span>
                </li>
                <li>
                  <span className="metric-label">
                    No high intensity sweeteners
                  </span>
                </li>
                <li>
                  <span className="metric-label">No digestive warnings</span>
                </li>
              </ul>
            </div>
            
            <div className="ingredient-visual">
              <img 
                src="/images/Ingredient_list.gif" 
                alt="Calowry Ingredient List Animation"
                className="ingredient-gif"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ProcessSection;
